import { isDefined } from './helpers';
import { ParallaxController } from 'parallax-controller';

export function initParallax()
{
    const parallaxElement = document.querySelectorAll('[data-speed]');
    
    if(!isDefined(parallaxElement))
    {
        return;
    }

    parallaxElement.forEach(function(item) {

        let speed = item.dataset.speed;
        let wrapper;
        let props = {};

        if(isDefined(item.dataset.wrapper))
        {
            wrapper =document.querySelector('.'+item.dataset.wrapper);
        }
        else
        {
            wrapper = document.body;
        }

        let instance = ParallaxController.init({
            wrapper
        });

        if(isDefined(item.dataset.translateStart) && isDefined(item.dataset.translateEnd))
        {
            let translate = [item.dataset.translateStart, item.dataset.translateEnd]; 
            props.translateY = translate;
        }

        props.speed = parseInt(speed);
        props.easing = "easeInCubic";

        let options = {
            el: item,
            props: props,
        };
        
        instance.createElement(options);
    })
}